import gql from 'graphql-tag';

const GET_REPORT_MODULES = gql`
  query {
    getDataReportModules
  }
`;

const GET_REPORT_DATA = gql`
  query($GetReportDataInput: GetReportDataInput!) {
    getReportData(input: $GetReportDataInput) {
      page
      pageSize
      data
      totalCount
    }
  }
`;

const EXPORT_REPORT = gql`
  query($ExportReportIdentifierInput: ExportReportIdentifierInput!) {
    exportReport(input: $ExportReportIdentifierInput)
  }
`;

const GET_ENTITY_META = gql`
  query($entityName: String) {
    getEntityMeta(entityName: $entityName) {
      name
      label
      attributes {
        name
        label
        attributePlaceHolder {
          key
          label
        }
        dataType
        isCustom
        entity
        uiDataType
        filterType
        useInGroupBy
        useInCondition
        autoComplete
      }
    }
  }
`;

const GET_REPORT = gql`
  query($reportId: ID!) {
    getReport(reportId: $reportId) {
      reportId
      name
      description
      createdBy {
        userId
        name
        email
      }
      internalName
      selectAttributes
      dataCondition
      groupBy
      createdTime
      entity
      reportType
      shareFilterCondition
      notificationTemplateId
      scheduleDefinition
      systemReport
    }
  }
`;

export {
  GET_REPORT_MODULES,
  GET_REPORT_DATA,
  EXPORT_REPORT,
  GET_ENTITY_META,
  GET_REPORT
};
